import { combineReducers } from "redux";
import banksReducer from "./banks/reducer";

export default combineReducers({
    banks: banksReducer,
});